// extracted by mini-css-extract-plugin
export default {"button":"NS2E1FzBFKRogXzf1DR4"};